/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getIndustryTypeByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getIndustryTypeByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "code": zod.string(),
  "name": zod.string()
})

export const listIndustryTypesQueryPageDefault = 1;export const listIndustryTypesQueryPageSizeDefault = 25;

export const listIndustryTypesQueryParams = zod.object({
  "page": zod.number().default(listIndustryTypesQueryPageDefault),
  "pageSize": zod.number().default(listIndustryTypesQueryPageSizeDefault)
})

export const listIndustryTypesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "code": zod.string(),
  "name": zod.string()
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

